import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../lib/stripe';

interface CheckoutProviderProps {
  children: React.ReactNode;
}

const ELEMENTS_OPTIONS = {
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: '#059669',
      fontFamily: 'Inter, system-ui, sans-serif',
    },
  },
};

export default function CheckoutProvider({ children }: CheckoutProviderProps) {
  return (
    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      {children}
    </Elements>
  );
}